// src/components/Navbar.jsx
import React, {useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {Menu, X} from "lucide-react";

export const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    // Check if the current path matches the link
    const isActive = (path) => {
        return location.pathname === path;
    };

    // Navigation items
    const navItems = [
        {path: "/", label: "Home"},
        {path: "/", label: "Contact-us"},
    ];
    const scroll = () => {
        const section = document.querySelector('#contact-us');
        section.scrollIntoView({behavior: 'smooth', block: 'start'});
    };

    const scrollToTop = () => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    };

    return (

        <nav className="sticky top-0 z-50 bg-[#1a1a1a] border-b border-[#FF4D00]/10 backdrop-blur-sm">
            <div className="max-w-7xl mx-auto px-4">
                <div className="flex items-center justify-between h-16">
                    {/* Logo */}
                    <Link to="/" className="flex items-center space-x-3">
                        <div className="w-8 h-8">
                            <img
                                src={require("../assets/helga_launcher_icon.png")}
                                alt="Helga Logo"
                                className="w-full h-full object-contain"
                            />
                        </div>
                        <span
                            className="text-base md:text-xl md:text-1xl font-bold bg-clip-text text-[#FF4D00]">
                                Helga Festival Companion
                             </span>
                    </Link>

                    {/* Desktop Navigation */}
                    <div className="hidden md:flex md:items-center md:space-x-8">

                    <div
                            style={{cursor: 'pointer',}}
                            onClick={scrollToTop}
                            className={`transition-colors duration-200 ${
                                isActive()
                                    ? "text-[#FF4D00]"
                                    : "text-gray-300 hover:text-[#FF4D00]"
                            }`}
                        >
                            Home
                        </div>
                        <div
                            style={{cursor: 'pointer',}}
                            onClick={scroll}
                            className={`transition-colors duration-200 ${
                                isActive()
                                    ? "text-[#FF4D00]"
                                    : "text-gray-300 hover:text-[#FF4D00]"
                            }`}
                        >
                            Get your festival app
                        </div>
                    </div>


                    {/* Mobile Menu Button */}
                    <div className="md:hidden">
                        <button
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                            className="text-gray-300 hover:text-[#FF4D00] transition-colors duration-200 flex mx-auto"
                        >
                            {isMenuOpen ? (
                                <X className="h-6 w-6"/>
                            ) : (
                                <Menu className="h-6 w-6"/>
                            )}
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile Navigation */}
            {isMenuOpen && (
                <div className="md:hidden">
                    <div className="px-2 pt-2 pb-3 space-y-1 bg-[#1a1a1a] border-t border-[#FF4D00]/10">
                    <div
                            style={{cursor: 'pointer',}}
                            onClick={scrollToTop}
                            className={`block px-3 py-2 rounded-md text-base font-medium transition-colors duration-200 ${
                                isActive()
                                    ? "text-[#FF4D00] bg-[#FF4D00]/10"
                                    : "text-gray-300 hover:text-[#FF4D00] hover:bg-[#FF4D00]/5"
                            }`}
                        >
                            Home
                        </div>
                        <div
                            style={{cursor: 'pointer',}}
                            onClick={scroll}
                            className={`block px-3 py-2 rounded-md text-base font-medium transition-colors duration-200 ${
                                isActive()
                                    ? "text-[#FF4D00] bg-[#FF4D00]/10"
                                    : "text-gray-300 hover:text-[#FF4D00] hover:bg-[#FF4D00]/5"
                            }`}
                        >
                            Get your festival app
                        </div>
                    </div>
                </div>
            )}

        </nav>


    )
        ;
};
